import { PageHeader } from "./ServiceDetail";
import { GoldButton, Reveal, SectionHeading } from "../components/ui-kit";
import { VALUES, METHOD_STEPS, IMAGES } from "../data/content";

export default function APropos() {
  return (
    <div data-testid="apropos-page">
      <PageHeader overline="À propos" title="KMR Event, l'ambiance qui vous ressemble" subtitle="KMR Event accompagne particuliers, entreprises, associations et collectivités dans la réussite de leurs événements, avec des prestations musicales, techniques et événementielles personnalisées." image={IMAGES.sax} />
      <section className="pb-16">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 space-y-6 text-lg text-foreground/80 leading-relaxed">
          <Reveal>
            <p>Notre promesse est simple : <span className="text-gold">la musique, l'ambiance et les partenaires qu'il faut pour donner vie à chaque événement.</span> Nous réunissons prestation musicale, sonorisation, éclairage et coordination de services complémentaires au sein d'un interlocuteur unique.</p>
            <p className="mt-6">Du mariage intime à la soirée d'entreprise, du festival associatif à la célébration familiale, nous adaptons chaque prestation à votre lieu, votre public et l'atmosphère que vous recherchez.</p>
          </Reveal>
        </div>
      </section>
      <section className="py-16 bg-[#0d0d0f]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <Reveal><SectionHeading overline="Nos valeurs" title="Ce qui nous guide" center /></Reveal>
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
            {VALUES.map((v, i) => (
              <Reveal key={v} delay={i * 0.05}>
                <div className="glass rounded-xl px-5 py-6 text-center hover:border-gold/40 transition-colors">
                  <span className="font-serif text-xl gold-text">{v}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <Reveal><SectionHeading overline="Notre méthode" title="Comment nous travaillons" /></Reveal>
          <div className="mt-12 space-y-4">
            {METHOD_STEPS.map((m, i) => (
              <Reveal key={m.n} delay={i * 0.06}>
                <div className="glass rounded-xl p-6 flex gap-6 items-start">
                  <span className="font-serif text-4xl gold-text opacity-50">{m.n}</span>
                  <div><h3 className="font-serif text-xl">{m.title}</h3><p className="text-muted-foreground mt-1">{m.desc}</p></div>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="text-center mt-12"><GoldButton to="/devis" data-testid="apropos-devis-btn">Parler de mon événement</GoldButton></div>
        </div>
      </section>
    </div>
  );
}
